import { render, staticRenderFns } from "./headlines-connect.vue?vue&type=template&id=09768fdf&scoped=true&"
import script from "./headlines-connect.vue?vue&type=script&lang=js&"
export * from "./headlines-connect.vue?vue&type=script&lang=js&"
import style0 from "./headlines-connect.vue?vue&type=style&index=0&id=09768fdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09768fdf",
  null
  
)

export default component.exports